export enum NewsType {
    LOWERED = 'verlaging',
    UPPED = 'verhoging',
    CHANGED = 'wijziging',
    NEW = 'nieuw',
}
